import React, { useState } from 'react';
import OrderAlerts from './components/OrderAlerts';
import OrderTable from './components/OrderTable';
import OrderDetailsModal from './components/OrderDetailsModal';
import { Box, Container, useDisclosure } from '@chakra-ui/react';

function Order() {
    const [selectedOrder, setSelectedOrder] = useState(null);
    const { isOpen, onOpen, onClose } = useDisclosure();

    const handleOrderClick = (order) => {
        setSelectedOrder(order);
        onOpen();
    };

    return (
       <Container maxW="xxl" mt={100} p={{ base: 4, md: 8 }} >
            <OrderTable />
        </Container>
    );
}

export default Order;
